import {CustomFieldModel} from '../../models/api/customFieldModel';
import {buildPublicId} from '../../models/applications/publicIdTypes';

/*
 * Computed properties.
 */

export function buildCustomFieldPublicId(customField: CustomFieldModel) {
  return buildPublicId('customField', customField.id);
}
